import { Reveal, Overline } from "@/components/motion";

const FULL_SERVICE = [
  "We deliver, install and plumb in the machine",
  "We fill it with freshly roasted beans, milk and supplies",
  "We clean, service and maintain it — you just drink the coffee",
];

const SUPPLY_SHIP = [
  "We still deliver, install and plumb in the machine — wherever you are",
  "Any machine maintenance or repairs are taken care of by us, always",
  "We ship beans, milk and supplies to you on a schedule",
  "Your team restocks the machine and runs the daily clean cycle",
  "Same 22p per cup to your charity, same support line, same Bean Ladder",
];

export const Coverage = () => (
  <section id="coverage" data-testid="coverage-section" className="py-24 sm:py-32 bg-white">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal><Overline>Where we operate</Overline></Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-4 font-display font-bold tracking-tight text-[#0B1E17] text-2xl sm:text-3xl lg:text-4xl max-w-2xl leading-tight">
          Full service on our home turf. Supply drops everywhere else.
        </h2>
      </Reveal>
      <div className="mt-14 grid lg:grid-cols-2 gap-6">
        <Reveal delay={0.12}>
          <div data-testid="coverage-full-service"
            className="h-full bg-[#0F2E23] text-[#FAF9F6] rounded-3xl p-8 sm:p-10 relative overflow-hidden grain">
            <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-[#34D399]/15 blur-[90px] pointer-events-none" />
            <p className="relative text-xs font-mono-brand font-semibold uppercase tracking-[0.22em] text-[#34D399]">Inside the service area</p>
            <h3 className="relative mt-4 font-display font-bold text-2xl sm:text-3xl">London &amp; Home Counties</h3>
            <p className="relative mt-2 text-sm text-[#FAF9F6]/60">Out as far as Oxford and Reading.</p>
            <ul className="relative mt-7 space-y-3.5">
              {FULL_SERVICE.map((t) => (
                <li key={t} className="flex items-start gap-3 text-sm text-[#FAF9F6]/80">
                  <span className="mt-0.5 w-5 h-5 shrink-0 rounded-full bg-[#D97706] text-white flex items-center justify-center text-[10px] font-bold">✓</span>
                  {t}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <div data-testid="coverage-supply-ship"
            className="h-full bg-[#F7F5F0] rounded-3xl border border-[#E2DDD3] p-8 sm:p-10">
            <p className="text-xs font-mono-brand font-semibold uppercase tracking-[0.22em] text-[#D97706]">Outside the area</p>
            <h3 className="mt-4 font-display font-bold text-2xl sm:text-3xl text-[#0B1E17]">Anywhere in the UK</h3>
            <p className="mt-2 text-sm text-[#52665E]">Installation, plumbing and machine maintenance are always on us — only the restocking shifts.</p>
            <ul className="mt-7 space-y-3.5">
              {SUPPLY_SHIP.map((t) => (
                <li key={t} className="flex items-start gap-3 text-sm text-[#52665E]">
                  <span className="mt-0.5 w-5 h-5 shrink-0 rounded-full bg-[#1B5E46] text-white flex items-center justify-center text-[10px] font-bold">✓</span>
                  {t}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
